import { render, staticRenderFns } from "./CardAction.vue?vue&type=template&id=2c4fdf72&scoped=true"
import script from "./CardAction.vue?vue&type=script&lang=js"
export * from "./CardAction.vue?vue&type=script&lang=js"
import style0 from "./CardAction.vue?vue&type=style&index=0&id=2c4fdf72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4fdf72",
  null
  
)

/* custom blocks */
import block0 from "./CardAction.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports